import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-msc-computer-science',
  templateUrl: './msc-computer-science.component.html',
  styleUrls: ['./msc-computer-science.component.scss']
})
export class MscComputerScienceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
